export const convertToFormData = (data) => {
    const fd = new FormData();
    for (const element of Object.keys(data)) {
      fd.append(element, data[`${element}`]);
    }
    return fd;
  };